var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5875 0.267933C12.716 0.285855 12.8368 0.340095 12.9356 0.424315L19.7567 6.10855C19.9109 6.23813 20 6.42924 20 6.63065C20 6.83223 19.9109 7.02335 19.7567 7.15291L12.9356 12.8371C12.8026 12.9466 12.6329 13.0016 12.4608 12.9912C12.2889 12.9807 12.1271 12.9055 12.0083 12.7807C11.8893 12.6559 11.8221 12.4908 11.82 12.3184V10.0518C10.2821 10.0664 4.99244 10.359 1.12634 13.7394C0.975195 13.8693 0.774724 13.9264 0.577733 13.896C0.380908 13.8653 0.207084 13.7504 0.102247 13.5808C-0.00274534 13.4114 -0.0282798 13.2046 0.0321437 13.0148C1.94233 7.12957 7.68354 4.52457 11.8196 3.39422V0.950034C11.8182 0.753367 11.9016 0.565585 12.0486 0.43488C12.1957 0.304175 12.3919 0.243451 12.5871 0.267872L12.5875 0.267933ZM13.1843 2.39952V3.90593C13.1843 4.05707 13.1342 4.2041 13.0416 4.32368C12.9489 4.44342 12.8192 4.52875 12.6727 4.56665C9.33049 5.41279 4.80039 7.30711 2.41261 11.1604C6.9807 8.47652 12.1042 8.66036 12.5379 8.68066C12.7125 8.68986 12.8771 8.76567 12.9973 8.89255C13.1177 9.01959 13.1846 9.18787 13.1845 9.3628V10.8621L18.2645 6.63461L13.1843 2.39952Z",
    fill: "#63637B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.12bfd4152ae0e699d4dee42ea58876d8.svg";
export { ForwardRef as ReactComponent };